import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ResponsiveImage } from '../../../../../ResponsiveImage';
import { DesktopNavigatorTabEditorialUnitFragment } from '../../../../../../generated/types';
import { DesktopSiteNavEditorialColumnText } from './DesktopSiteNavEditorialColumnText';

import './DesktopSiteNavEditorialColumn.scss';

interface Props {
  className?: string;
  active: boolean;
  content: DesktopNavigatorTabEditorialUnitFragment;
}

export const DesktopSiteNavEditorialColumn: React.FC<Props> = ({
  className,
  content: { imageSrc, imageAlt, href, headline, anchorText },
  active
}) => (
  <div className={classNames('DesktopSiteNavEditorialColumn', className)}>
    <Link className="DesktopSiteNavEditorialColumn__anchor" to={href || ''}>
      <DesktopSiteNavEditorialColumnText text={headline} />

      {imageSrc && active && (
        <ResponsiveImage
          src={imageSrc}
          maxWidth={160}
          maxHeight={260}
          alt={imageAlt || 'Editorial Image'}
        />
      )}

      {anchorText && <DesktopSiteNavEditorialColumnText text={anchorText} />}
    </Link>
  </div>
);
